// extracted by mini-css-extract-plugin
export var marginNegative = "_76-5 _76-3 _76-1";
export var marginPositive = "_76-4 _76-3 _76-1";
export var modalContent = "_76-6";
export var samplesTable = "_76-8";
export var samplesTableContainer = "_76-7";
export var statBox = "_76-a";
export var tableCell = "_76-1";
export var tableCellCenter = "_76-2 _76-1";
export var tableCellRight = "_76-3 _76-1";
export var tableHeader = "_76-0";
export var trackingNumber = "_76-9";